<div class="notificationsButton mx-0">
  <button mat-button data-cy="toggle-notifications-sidenav-button" (click)="toggleNotificationsSidenav()">
    <mat-icon
      svgIcon="bell"
      class="icon--large"
      aria-hidden="false"
      [matBadge]="notifications()?.length"
      [matBadgeHidden]="!notifications()?.length" />
  </button>

  @if (anyNotificationInProgress()) {
    <mat-progress-bar class="notificationProgressBar" mode="indeterminate" />
  }
</div>
